function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgComingSoon = function SvgComingSoon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 472 418.41",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M306.67 63.73a189.8 189.8 0 0 0-45.38.01V22.67c0-30.23 45.38-30.23 45.38 0z",
    style: {
      fill: "#ee751e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.98 42.38c-103.83 0-188.01 84.19-188.01 188.02s84.18 188.01 188.01 188.01S472 334.23 472 230.4 387.82 42.38 283.98 42.38",
    style: {
      fill: "#ee751e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.37 73.34c-121.48-43.55-251.4 46.26-251.4 177.06-.04 63.27 31.78 122.3 84.64 157.06-74.76-26.79-124.63-97.65-124.64-177.06 0-103.83 84.18-188.02 188.01-188.02 36.76-.06 72.72 10.71 103.39 30.96",
    style: {
      fill: "#f09655"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.98 81.09c-82.46 0-149.3 66.85-149.29 149.31 0 82.46 66.85 149.3 149.31 149.29 82.45 0 149.28-66.84 149.29-149.29 0-82.46-66.83-149.3-149.29-149.31z",
    style: {
      fill: "#f6f7fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.68 256.41a149.03 149.03 0 0 0 56.72 117.14c-79.05-23.52-124.06-106.66-100.54-185.71S247.52 63.78 326.57 87.3c18.16 5.4 35.12 14.21 49.99 25.96-95.65-28.43-191.88 43.36-191.88 143.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.98,
    cy: 350.21,
    r: 8,
    style: {
      fill: "#62839d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.89,
    cy: 334.16,
    r: 8,
    style: {
      fill: "#62839d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.08,
    cy: 334.16,
    r: 8,
    style: {
      fill: "#62839d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.75,
    cy: 290.31,
    r: 8,
    style: {
      fill: "#62839d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.22,
    cy: 290.31,
    r: 8,
    style: {
      fill: "#62839d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.8,
    cy: 230.4,
    r: 8,
    style: {
      fill: "#62839d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.17,
    cy: 230.4,
    r: 8,
    style: {
      fill: "#62839d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.75,
    cy: 170.49,
    r: 8,
    style: {
      fill: "#62839d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.22,
    cy: 170.49,
    r: 8,
    style: {
      fill: "#62839d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.89,
    cy: 126.64,
    r: 8,
    style: {
      fill: "#62839d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.08,
    cy: 126.64,
    r: 8,
    style: {
      fill: "#62839d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.86 298.41c-4.42 0-8-3.6-7.99-8.03 0-1.41.38-2.8 1.09-4.02l22.28-38.07c2.2-3.83 7.09-5.16 10.92-2.96s5.16 7.09 2.96 10.92c-.02.04-.05.08-.07.12l-22.28 38.07a8.02 8.02 0 0 1-6.91 3.96ZM283.98 212.98c-4.42 0-8-3.58-8-8v-86.35c0-4.42 3.58-8 8-8s8 3.58 8 8v86.35c0 4.42-3.58 8-8 8",
    style: {
      fill: "#62839d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.98 204.98c14.04 0 25.42 11.37 25.42 25.41s-11.37 25.42-25.41 25.42-25.42-11.37-25.42-25.41 11.37-25.42 25.41-25.42",
    style: {
      fill: "#06437b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.97 418.4h-9.9c-4.42 0-8-3.58-8-8s3.58-8 8-8h9.9c4.42 0 8 3.58 8 8s-3.58 8-8 8M85.81 418.4H8c-4.42 0-8-3.58-8-8s3.58-8 8-8h77.81c4.42 0 8 3.58 8 8s-3.58 8-8 8M95.97 358.4H24.23c-4.42 0-8-3.58-8-8s3.58-8 8-8h71.74c4.42 0 8 3.58 8 8s-3.58 8-8 8M75.97 298.4H41.78c-4.42 0-8-3.58-8-8s3.58-8 8-8h34.19c4.42 0 8 3.58 8 8s-3.58 8-8 8M55.97 238.4h-44.2c-4.42 0-8-3.58-8-8s3.58-8 8-8h44.19c4.42 0 8 3.58 8 8s-3.58 8-8 8ZM75.97 178.4H41.78c-4.42 0-8-3.58-8-8s3.58-8 8-8h34.19c4.42 0 8 3.58 8 8s-3.58 8-8 8M95.97 118.4H21.65c-4.42 0-8-3.58-8-8s3.58-8 8-8h74.32c4.42 0 8 3.58 8 8s-3.58 8-8 8M155.97 58.4H91.71c-4.42 0-8-3.58-8-8s3.58-8 8-8h64.26c4.42 0 8 3.58 8 8s-3.58 8-8 8M51.84 58.4H41.77c-4.42 0-8-3.58-8-8s3.58-8 8-8h10.06c4.42 0 8 3.58 8 8s-3.58 8-8 8Z",
    style: {
      fill: "#135899"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgComingSoon);
export default ForwardRef;